import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  MenuItem,
  Menu,
  Button,
  ButtonGroup,
  Box,
} from '@mui/material';
import MoreIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import { connect, useSelector, useDispatch } from 'react-redux';
import { history } from '../../utils/history';

const classes: any = {
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: 20,
  },
  headerLinks: {
    textDecoration: 'none',
    padding: 20,
    paddingLeft: '50px',
    paddingRight: '50px',
    color: '#0B2240',
    fontWeight: 900,
  },
  sectionDesktop: {
    display: { xs: 'none', md: 'flex' },
  },
  sectionMobile: {
    display: { xs: 'flex', md: 'none' },
    justifyContent: 'space-between',
    padding: '0 !important',
  },
  appBar: {
    display: 'flex',
    borderBottom: `solid 1px #1976D2`,
    backgroundColor: 'text.disabled',
    alignItems: 'space-between',
    justifyContent: 'center',
    top: 0,
    bottom: 'auto',
    height: 55,
    overflow: 'hidden',
    zIndex: 400,
  },
  mobileMenuStyle: {
    textDecoration: 'none',
    padding: '10',
    backgroundColor: '#FFFFFF',
    color: 'black',
  },
  popover: {
    marginTop: 40,
  },
  menuLinks: {
    width: 200,
    alignText: 'center',
    justifyContent: 'center',
  },
  logo: {
    width: 150,
  },
  clubName: {
    textDecoration: 'none',
    fontWeight: 900,
    fontSize: 20,
    textTransform: 'uppercase',
    backgroundColor: 'white',
  },
};

function Header(props: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const [profileMoreAnchorEl, setProfileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isProfileMenuOpen = Boolean(profileMoreAnchorEl);
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleProfileMenuClose = () => {
    setProfileMoreAnchorEl(null);
  };
  const dispatch: any = useDispatch();
  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setProfileMoreAnchorEl(event.currentTarget);
  };
  const { i18n } = useTranslation();

  const changeLanguage = (lng: any) => {
    i18n.changeLanguage(lng);
  };

  const signOut = () => {
    history.push(`/memberfitness/signin`);
    dispatch({ type: 'FAKE_LOGOUT' });
    handleMenuClose();
  };
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );
  const renderProfileMenu = (
    <div>
      <Menu
        anchorEl={profileMoreAnchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isProfileMenuOpen}
        onClose={handleProfileMenuClose}
        sx={classes.popover}
      >
        <Typography sx={{ m: 1 }} color="secondary" align="center">
          Set Language
        </Typography>
        <MenuItem
          className={classes.menuLinks}
          onClick={() => changeLanguage('fr')}
        >
          French
        </MenuItem>
        <MenuItem
          className={classes.menuLinks}
          onClick={() => changeLanguage('en')}
        >
          English
        </MenuItem>
        <MenuItem
          className={classes.menuLinks}
          onClick={() => changeLanguage('es')}
        >
          Spanish
        </MenuItem>
      </Menu>
    </div>
  );
  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <div className={classes.mobileMenuStyle}>
      <Menu
        sx={{ mt: 4 }}
        anchorEl={mobileMoreAnchorEl}
        // anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        id={mobileMenuId}
        keepMounted
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
      >
        <div className={classes.headerLinks}>
          <ButtonGroup
            sx={{ minWidth: 120 }}
            variant="text"
            orientation="vertical"
          >
            {/* <Button disabled style={{ color: "black" }}>
							Menu Options
						</Button> */}
            <Button
              sx={{ minWidth: 120, color: 'white' }}
              fullWidth
              onClick={() => signOut()}
            >
              Sign Out
            </Button>
            {/* <Button color="primary">FAQs</Button>
						<Button>Help</Button>
						<Button>Contact</Button> */}
          </ButtonGroup>
        </div>
      </Menu>
    </div>
  );
  let active = useSelector((state: any) => state.auth.active);

  return (
    <div className={classes.grow}>
      {active && (
        <div>
          <AppBar sx={classes.appBar} position="fixed">
            <Toolbar
              sx={{
                justifyContent: 'space-between',
              }}
            >
              {/* <img src={Logo} width={160} alt="logo" /> */}
              <div style={{ overflow: 'hidden', display: 'inline-block' }}>
                <Typography
                  color="primary.main"
                  sx={{
                    bgcolor: 'text.disabled',
                    textDecoration: 'none',
                    fontWeight: 900,
                    fontSize: 20,
                    textTransform: 'uppercase',
                  }}
                  variant="h5"
                >
                  <span style={{ color: 'white' }}>MEMBER</span>{' '}
                  <span style={{ color: '#1976D2' }}>FITNESS</span>
                </Typography>
              </div>
              <div className={classes.grow} />
              {/* <IconButton
								aria-label="show 3 new notifications"
								color="inherit"
								onClick={handleProfileMenuOpen}
							>
								{currentUser || props.user ? <LanguageSharpIcon /> : ""}
							</IconButton> */}

              <Box sx={classes.sectionMobile}>
                <IconButton
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                  style={{ padding: 0 }}
                  size="large"
                >
                  <MoreIcon />
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderProfileMenu}
          {renderMenu}
          {/* <Alert /> */}
        </div>
      )}
    </div>
  );
}

export default Header;
